/**
 * -----------------------------------------------------------------------------
 * It renders a file icon.
 */
export function FileIcon() {
  return (
    <svg fill="none" viewBox="0 0 32 32" width={32}>
      <g
        className="stroke-gray-950"
        clipPath="url(#a)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.2}
      >
        <path
          className="fill-green-200"
          d="M25 28H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12l7 7v16a1 1 0 0 1-1 1Z"
        />
        <path d="M19 4v7h7" />
      </g>
      <defs>
        <clipPath id="a">
          <path className="fill-white" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
